import React from 'react';
import {
  LockOutlined,
  SafetyOutlined,
  CloudOutlined,
  CloudServerOutlined,
  CloudUploadOutlined,
  DatabaseOutlined,
  MailOutlined,
  TeamOutlined,
  SettingOutlined,
  ToolOutlined,
  BugOutlined,
  AlertOutlined,
  AuditOutlined,
  SecurityScanOutlined,
  KeyOutlined,
  ApiOutlined,
  GlobalOutlined,
  DesktopOutlined,
  MobileOutlined,
  WifiOutlined,
  ThunderboltOutlined,
  FileProtectOutlined,
  SafetyCertificateOutlined,
  EyeOutlined,
  SyncOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  ReadOutlined,
  WarningOutlined,
  RobotOutlined,
} from '@ant-design/icons';

/**
 * Maps icon name strings (stored in DB) to actual Ant Design icon components.
 * Used by DropZone and DraggableTemplate to render icons properly.
 */
const ICON_MAP = {
  LockOutlined: <LockOutlined />,
  SafetyOutlined: <SafetyOutlined />,
  ShieldOutlined: <SafetyOutlined />,
  CloudOutlined: <CloudOutlined />,
  CloudServerOutlined: <CloudServerOutlined />,
  CloudUploadOutlined: <CloudUploadOutlined />,
  DatabaseOutlined: <DatabaseOutlined />,
  MailOutlined: <MailOutlined />,
  TeamOutlined: <TeamOutlined />,
  SettingOutlined: <SettingOutlined />,
  ToolOutlined: <ToolOutlined />,
  BugOutlined: <BugOutlined />,
  AlertOutlined: <AlertOutlined />,
  AuditOutlined: <AuditOutlined />,
  SecurityScanOutlined: <SecurityScanOutlined />,
  KeyOutlined: <KeyOutlined />,
  ApiOutlined: <ApiOutlined />,
  GlobalOutlined: <GlobalOutlined />,
  DesktopOutlined: <DesktopOutlined />,
  MobileOutlined: <MobileOutlined />,
  WifiOutlined: <WifiOutlined />,
  ThunderboltOutlined: <ThunderboltOutlined />,
  FileProtectOutlined: <FileProtectOutlined />,
  SafetyCertificateOutlined: <SafetyCertificateOutlined />,
  EyeOutlined: <EyeOutlined />,
  SyncOutlined: <SyncOutlined />,
  CheckCircleOutlined: <CheckCircleOutlined />,
  ClockCircleOutlined: <ClockCircleOutlined />,
  ReadOutlined: <ReadOutlined />,
  WarningOutlined: <WarningOutlined />,
  RobotOutlined: <RobotOutlined />,
};

/**
 * Resolve an icon value to a renderable element.
 * If the value is a known Ant Design icon name string, returns the component.
 * If it's already an emoji or other string, returns it as-is.
 * Falls back to a clipboard emoji.
 */
export const resolveIcon = (icon) => {
  if (!icon) return '📋';
  if (ICON_MAP[icon]) return ICON_MAP[icon];
  // Already an emoji or unknown string - render as-is
  return icon;
};

export default ICON_MAP;
